export default __webpack_public_path__ + "static/media/visitors.630df1dc.png";